import { getUserByEmail, getCachedUserPhoto } from './graphService';

// In-memory cache for user details
const userDetailsCache = new Map();
const CACHE_EXPIRY = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

class GraphUserService {
    async getUserDetails(email) {
        try {
            // Check cache first
            const cachedData = userDetailsCache.get(email);
            if (cachedData && (Date.now() - cachedData.timestamp) < CACHE_EXPIRY) {
                return cachedData.data;
            }
            
            // Get user details from Graph API
            const user = await getUserByEmail(email);

            // Get user photo
            let photoUrl = null;
            try {
                photoUrl = await getCachedUserPhoto(email);
            } catch (photoError) {
                // Photo not available
            }

            const userDetails = {
                displayName: user.displayName,
                email: user.mail || user.userPrincipalName,
                jobTitle: user.jobTitle,
                avatarUrl: photoUrl
            };

            // Update cache
            userDetailsCache.set(email, {
                data: userDetails,
                timestamp: Date.now()
            });

            return userDetails;
        } catch (error) {
            console.error('GraphUserService: Error fetching user details:', error);
            return {
                displayName: email,
                email: email,
                avatarUrl: null
            };
        }
    }

    clearCache() {
        userDetailsCache.clear();
    }
}

export const graphUserService = new GraphUserService(); 